import type { Configuration } from "@azure/msal-browser";
import { LogLevel } from "@azure/msal-browser";

type LoggerOptions = NonNullable<
  NonNullable<Configuration["system"]>["loggerOptions"]
>;

const levels: Record<string, LogLevel> = {
  error: LogLevel.Error,
  warning: LogLevel.Warning,
  info: LogLevel.Info,
  verbose: LogLevel.Verbose,
};

export function msalLoggerOptions(
  configuredLevel: string,
): LoggerOptions | undefined {
  const logLevel = levels[configuredLevel.trim().toLowerCase()];
  if (logLevel === undefined) {
    return undefined;
  }
  return {
    logLevel,
    piiLoggingEnabled: false,
    loggerCallback: (level: LogLevel, message: string) => {
      const line = `[msal] ${message}`;
      if (level === LogLevel.Error) {
        console.error(line);
      } else if (level === LogLevel.Warning) {
        console.warn(line);
      } else {
        console.info(line);
      }
    },
  };
}
